<table class="table table-bordered">
    <thead>
        <tr>
            <th>Actions</th>
            <th>Fraction Unit</th>
            <th>Start Value</th>
            <th>Threshold end</th>
            <th>Duration</th>
            <th>Amount</th>
            <th>Max Threshold</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td><i class="material-icons-outlined">edit</i><i class="material-icons-outlined">delete</i></td>
            <td>Minutes</td>
            <td>0</td>
            <td>30</td>
            <td>30</td>
            <td>100.00</td>
            <td></td>
        </tr>
        <tr>
            <td><i class="material-icons-outlined">edit</i><i class="material-icons-outlined">delete</i></td>
            <td>Minutes</td>
            <td>31</td>
            <td>60</td>
            <td>30</td>
            <td>50.00</td>
            <td></td>
        </tr>
    </tbody>
</table>